// Custom event names used for overlay coordination
export const OVERLAY_EVENTS = {
  BOTTOM_DOCK_CHANGED: 'bottom-dock-changed',
} as const
